import { Cart, CartModification, CartUiEventAddToCart, OrderEntry } from '@spartacus/cart/base/root';
import { Price } from "@spartacus/core";
import { Observable } from 'rxjs';


export interface DirectInputEntry {
  code?: string;
  quantity?: Number;
  note?: string;
}

export interface DirectInputForm {
  entries?: DirectInputEntry[];
}

export interface UigCartModification extends CartModification {
  notListed?: boolean;
}

declare module '@spartacus/cart/base/root' {
  interface Cart {
    publicCart: boolean;
    isOwner: boolean;
    activeCartForUser: boolean;
    deliveryTicket: string;
    deliveryCostBulkyDirect?: Price;
    vendorOrderGroups?: VendorOrderEntryGroup[];
    groupSums?: GroupSum[];
    deliveryCostDirect?: Price;
    deliveryCostDirectTotal?: Price;
  }
}

export interface VendorOrderEntryGroup {
  vendorName?: string;
  vendorCode?: string;
  entries?: OrderEntry[];
  totalPrice?: Price;
  deliveryCost?: Price;
  noteText?:string;
  quantity?:number;
}

export interface GroupSum {
  deliveryCost?: Price;
  totalPrice?: Price;
  vendorCode?: string;
}

export interface UpdateCartEntryNote {
  result?: string;
}

export class UigCartUiEventAddToCart extends CartUiEventAddToCart {
  entry$?: Observable<OrderEntry>;
  cart$?: Observable<Cart>;
  loaded$?: Observable<boolean>;
}
